module.exports = __webpack_public_path__ + "media/Video_Joshua_Jacob.fa4207ff.mp4";